'use strict';

/**
 *
 * @name: nownessApp.components
 *
 */

// Modules
import AddOnsModule from './nn-add-ons/nn-add-ons.module';
import AnalyticsModule from './nn-analytics/nn-analytics.module';
import ApiModule from './_api/_api.module';
import BaseComponentsModule from './nn-base-components/nn-base-components.module';
import BookmarkModule from './nn-bookmark/nn-bookmark.module';
import GenericDirectivesModule from './nn-generic-directives/nn-generic-directives.module';
import GenericServicesModule from './nn-generic-services/nn-generic-services.module';
import ModalsModule from './nn-modals/nn-modals.module';
import ModulesModule from './nn-modules/nn-modules.module';
import NavigationModule from './nn-navigation/nn-navigation.module';
import NnPersistentVideo from './nn-persistent-video/nn-persistent-video.module';
import NnPlayerDrawer from './nn-player-drawer/nn-player-drawer.module';
import NnPlayersModule from './nn-players/nn-players.module';
import PartialsModule from './nn-partials/nn-partials.module';
import RegisterModule from './nn-register/nn-register.module';
import SocialModule from './nn-social/nn-social.module';
import TranslationsModule from './nn-translations/nn-translations.module';

// Directives
import NnSeasonItemDirective from './nn-season-item/nn-season-item.directive';

const ComponentsModule = angular
  .module('nownessApp.components', [
    AddOnsModule,
    AnalyticsModule,
    ApiModule,
    BaseComponentsModule,
    BookmarkModule,
    GenericDirectivesModule,
    GenericServicesModule,
    ModalsModule,
    ModulesModule,
    NavigationModule,
    NnPersistentVideo,
    NnPlayerDrawer,
    NnPlayersModule,
    PartialsModule,
    RegisterModule,
    SocialModule,
    TranslationsModule,
  ])
  .directive('nnSeasonItem', NnSeasonItemDirective);

export default ComponentsModule.name;



// WEBPACK FOOTER //
// ./app/components/components.module.js